// Telegram Image Component
import React from 'react';

interface TelegramImageProps {
  imageUrl: string;
  fileId?: string | null;
  alt: string;
  className?: string;
}

export default function TelegramImage({ imageUrl, fileId, alt, className = '' }: TelegramImageProps) {
  // Determine image source: prefer Telegram if available
  const imageSrc = React.useMemo(() => {
    if (fileId && fileId !== 'null') {
      const apiUrl = import.meta.env.VITE_API_URL || '';
      return `${apiUrl}/api/telegram/image/${fileId}`;
    }
    return imageUrl || '';
  }, [fileId, imageUrl]);

  if (!imageSrc) {
    return (
      <div className={`bg-gray-100 rounded flex items-center justify-center h-48 ${className}`}>
        <div className="text-center p-4">
          <div className="text-gray-500 text-sm">No image available</div>
        </div>
      </div>
    );
  }

  return (
    <a
      href={imageSrc}
      target="_blank"
      rel="noopener noreferrer"
      className={`relative group block ${className}`}
    >
      <img
        src={imageSrc}
        alt={alt}
        className="w-full h-48 object-cover rounded hover:opacity-90 transition-opacity"
      />
      
      {/* Hover overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all rounded flex items-center justify-center pointer-events-none">
        <span className="text-white opacity-0 group-hover:opacity-100 text-sm font-medium">
          🔍 点击查看大图
        </span>
      </div>
      
      {/* Source indicator */}
      <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        <span className="px-2 py-1 bg-black bg-opacity-60 text-white text-xs rounded">
          {fileId && fileId !== 'null' ? '📡 Telegram' : '🌐 原图'}
        </span>
      </div>
    </a>
  );
}
